// removed by extract-text-webpack-plugin
module.exports = {"header":"_3BCLfzwxYHfoJa_jOyVP67","logo":"WlpKvw1CdOCB_qZKu9OFU","sandboxWarning":"_2hwsg9C5f_iTiwM1SSylZ_","sandboxWarningBold":"QgkGWdvZzqOACPqUjnmk0","sandboxWarningText":"_1NyXtl7j6q9r-A_MzKn-8T"};


//////////////////
// WEBPACK FOOTER
// ./src/Header/Header.css
// module id = 153
// module chunks = 0